// Calibration scores once per video: no composite slot (compositeIndex is null, which
// keeps them out of the Evaluate composite UI) and a fixed round. The server reconciles
// by (calibrationAssignmentId, calibrationVideoId) only — round is metadata.
export const CALIBRATION_ROUND = 1;
